<template lang="pug">
  .credits-table(v-if="Array.isArray(tableData) && tableData.length")
    ods-table(
      style='width: 100%'
      :data='tableData'
      :default-sort = "{prop: 'tariff', order: 'descending'}"
      )
      ods-table-column(prop='codterm' label='Código de terminal' sortable)
      ods-table-column(prop='texto' label='Texto' sortable)
      ods-table-column(prop='descripsit' label='Situación' sortable)
      ods-table-column(prop='usuario' label='Usuario' sortable)
      ods-table-column(prop='fecalta.valueDate' label='Fecha de alta')
      ods-table-column(prop='telefono' label='Teléfono')
      ods-table-column(prop='object' label='Acciones' class-name="cell-actions")
        template(slot-scope="scope")
          ods-actions-menu(
            customClass="card-menu"
            icon="overflow-menu"
            color="#888A91"
            size="18"
            popoverPosition="bottom-end")
            ul.menu
              li.menu__item
                a(href="#" @click.prevent="openModifyModal(scope.$index, scope.row)")
                  ods-icon(name="eye" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
                  | Ver detalle
              li.menu__item
                a(href="#" @click.prevent="deleteTPV(scope.row.codterm)" style="color: #DE2F2F")
                  ods-icon(name="delete" color="#DE2F2F" size="24" style="vertical-align: middle").ods-mr-2
                  | Eliminar terminal

    ods-pagination(
      :page-sizes = '[5, 10, 50, 100]',
      :page-size = itemsPerPage,
      layout='total, sizes, prev, pager, next',
      :total='totalData'
      @size-change='handleSizeChange',
      @current-change='handleCurrentChange'
      style="text-align: right; margin-top: 20px")

    ventana-borrar-terminal(
      @mostrarTerminal="mostrarTpvs"
      :codcomercio="codcomercio"
      :isVisible="dialogVisible"
      :rowDelete="rowSeleccionada"
      :toggleVisible="toggleDeleteTerminal"
      @closingDialog="dialogVisible = $event")

    ventana-modificar-terminal(
      :codcomercio="codcomercio"
      :isVisible="dialogModificarVisible"
      :rowModify="rowSeleccionada"
      :toggleVisible="toggleModifyTerminal"
      @closingDialog="dialogModificarVisible = $event")

  p.notfound(v-else) No se han encontrado resultados

</template>

<script>
import VentanaBorrarTerminal from '@/components/dialogs/VentanaBorrarTerminal'
import VentanaModificarTPV from '@/components/dialogs/VentanaModificarTPV'

export default {
  name: 'TpvTable',

  components: {
    VentanaBorrarTerminal,
    VentanaModificarTPV
  },

  props: {
    data: {
      required: true
    }
  },

  data () {
    return {
      expandKey: [],
      tableData: this.data,
      itemsPerPage: 10,
      currentPageData: 1,
      totalData: 0
    }
  },

  watch: {
    data (newData, oldData) {
      this.totalData = newData.length
      this.tableData = newData
    }
  },

  methods: {
    handleSizeChange (val) {
      this.itemsPerPage = val
      this.handlePagination()
    },

    handleCurrentChange (val) {
      this.currentPageData = val
      this.handlePagination()
    },

    handlePagination (arr) {
      if (Array.isArray(this.data)) {
        this.tableData = this.data.slice(
          (this.currentPageData - 1) * this.itemsPerPage,
          this.currentPageData * this.itemsPerPage)
      }
    },

    editTPV (numvendor) {
      this.$emit('editTPV', numvendor)
    },

    detailTPV (numvendor) {
      this.$emit('detailTPV', numvendor)
    },

    deleteTPV (numvendor) {
      this.$emit('deleteTPV', numvendor)
    },

    openModifyModal (index, row) {
      this.rowSeleccionada = row
      this.toggleModifyTerminal()
    }
  },

  mounted () {
    if (Array.isArray(this.data)) this.totalData = this.data.length
    this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24)!important;
  background: #F9F9FB;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #F9F9FB!important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td, .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #F0F0F0!important;
  }
}
</style>
